import { useField } from '@framework/form/field/useField.tsx';
import {
  FormItem,
  type IFormItemProps,
} from '@framework/form/item/FormItem.tsx';
import { useTheme } from 'styled-components';
import { useWidgetComponentContext } from '../../schema/widgets/context/WidgetComponentContext.tsx';
import { type IInputWidget } from '../../schema/widgets/repository/inputs/IInputWidget.ts';

interface IConfigFormItemProps<T> extends IFormItemProps {
  widget: IInputWidget;
}

/**
 * Componente FormItem utilizzato dai Widget, per eventuali modifiche di stile
 * del `FormItem` dedicate ai widget.
 */
export function ConfigFormItem<
  T extends Record<string, any> = Record<string, any>,
>(props: IConfigFormItemProps<T>) {
  const { isOnlyWidgetReadonly } = useWidgetComponentContext();
  const theme = useTheme();

  const { widget, ...formItemProps } = props;
  const isRequired = widget.rules?.required?.value === true;

  const { enabled } = useField(props.name);

  const required = formItemProps.required ?? (enabled ? undefined : isRequired);

  return (
    <FormItem
      {...formItemProps}
      required={required}
      visuallyDisabled={
        /**
         * Solamente se espressamente configurato nel tema: se il widget è
         * readonly, allora il FormItem viene reso "visually disabled".
         */
        props.visuallyDisabled ||
        (isOnlyWidgetReadonly && theme.showIntegrationReadonlyWidgetsAsDisabled)
      }
    />
  );
}
